import { createProviderToken } from '@core/common-legacy';

/**
 * Contract for branding assets used in report exports (e.g. PDF footer logo).
 * Enables domain-specific implementations (e.g. Recruitee logo vs Tellent logo).
 */
export interface ReportsExportsBranding {
  pdfFooterLogoSvg: () => Promise<string>;
}

export const { inject: injectReportsExportsBranding, provide: provideReportsExportsBranding } =
  createProviderToken<ReportsExportsBranding>('ReportsExportsBranding')();
